<template>
  <div class="freightInquiry">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true"> {{ $t.orderDetail.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <div class="list-title">
      <van-image width="15" height="15" :src="earthIcon"></van-image>
      <span class="label">{{ $t.freightInquiry.placeHolder }}</span>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div
        class="detail"
        v-for="(item, index) in tableData"
        :key="index"
        @click="gotoDetail(item.FPId)"
      >
        <div class="left">
          <van-image
            width="50"
            height="50"
            fit="cover"
            round
            :src="imgUrlFilter(item.NationalFlagPicture)"
          ></van-image>
        </div>
        <div class="right">
          <div class="country">{{ item.CountryName }}</div>
        </div>

        <div class="arrow">
          <van-icon name="arrow" />
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <div class="tool-bar">
      <van-button block :icon="calculatorIcon" @click="gotoCalculator">{{
        $t.home.freightPriceCalculator
      }}</van-button>
    </div>
  </div>
</template>
<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Icon,
  Image,
  Popup,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Icon)
  .use(Image)
  .use(Popup)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "freightInquiry",
  data() {
    return {
      earthIcon: require("@/assets/img/freightInquiry/earth.png"),
      calculatorIcon: require("@/assets/img/freightInquiry/calculator.png"),
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      showFilter: false,
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.freightInquiry.countryName,
          value: 1,
        },
        {
          text: this.$t.freightInquiry.cargoCategory,
          value: 2,
        },
      ],
    };
  },
  created() {},
  methods: {
    gotoCalculator() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "freightPriceCalculator",
        name: "freightPriceCalculator",
        query: [],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.search;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      return false;
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CountryName: this.searchType == 1 ? this.searchText : "",
        CargoCategory: this.searchType == 2 ? this.searchText : "",
      };
      this.$api.customerManagement
        .getFreightPriceListByPage(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "freightInquiryDetail",
        name: "freightInquiryDetail",
        query: [
          {
            name: "FPId",
            value: id,
          },
        ],
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.freightInquiry {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            color: #969799;
            padding: 5px 8px 5px 8px;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list-title {
    margin-top: 2.5%;
    margin-left: 2.5%;
    .van-image {
      vertical-align: middle;
      display: inline-block;
    }
    .label {
      font-size: 12px;
      font-weight: 500;
      vertical-align: middle;
      display: inline-block;
      margin-left: 5px;
    }
  }
  .list {
    .detail {
      width: 45.5%;
      background: #fff;
      margin: 2.5% 0px 0px 2.5%;
      padding: 10px 0px 10px 0px;
      display: inline-block;
      border-radius: 10px;
      border: 1px solid #e5e5e5;
      box-shadow: 0px 2.5px 5px 0px rgba(0, 0, 0, 0.1);
      .left {
        vertical-align: middle;
        display: inline-block;
        width: 45%;
        text-align: center;
      }
      .right {
        vertical-align: middle;
        display: inline-block;
        width: 40%;
        .country {
          color: #333;
          font-size: 12px;
          font-weight: bold;
        }
      }
      .arrow {
        text-align: center;
        vertical-align: middle;
        display: inline-block;
        width: 15%;
        .van-icon {
          font-size: 14px;
          font-weight: bold;
          color: #999;
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
    ::v-deep .van-radio__icon--checked {
      .van-icon-success {
        background-color: #2750aa !important;
        border-color: #2750aa !important;
      }
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
  }
  .popup-footer {
    position: fixed;
    bottom: calc(0px + env(safe-area-inset-bottom));
    width: 100%;
    text-align: center;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 2.5%;
    z-index: 10;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      width: 90%;
      margin: auto;
      border: none;
      border-radius: 10px;
      color: #ffffff;
      background: #2750aa !important;
      .van-button__icon {
        margin-top: 2px;
      }
      .van-button__text {
        font-size: 14px !important;
      }
    }
  }
}
</style>
